
import { libTypes } from "@holta/lib";
import styled from 'styled-components';

export const ProductionStausDot = styled.div<{size: number, status: libTypes.ProductionStatus }>`
    width: ${props => props.theme.spacing(props.size)};
    height: ${props => props.theme.spacing(props.size)};
    border-radius: 1000px;
    background-color: ${props => (props.theme.color as {[index : string] : string})['production_' + props.status]};
`;